// src/redux/scanSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { Scan } from '../../domain/models/ItemScan';

export const initialStateScan: Scan = {
  scan: [],
};

const scanSlice = createSlice({
  name: 'scan',
  initialState: initialStateScan,
  reducers: {
    addToScan: (state, action) => {
      const itemInScan = state.scan.find(
        (item) => item.barcode === action.payload.barcode
      );
      if (itemInScan) {
        itemInScan.quantity++;
      } else {
        state.scan.push({ ...action.payload, quantity: 1 });
      }
    },
    incrementQuantity: (state, action) => {
      const item = state.scan.find((item) => item.barcode === action.payload);
      if (item) {
        item.quantity++;
      }
    },
    decrementQuantity: (state, action) => {
      const item = state.scan.find((item) => item.barcode === action.payload);
      if (item?.quantity === 1) {
        item.quantity = 1;
      } else {
        if (item) {
          item.quantity--;
        }
      }
    },
    removeItem: (state, action) => {
      const removeItem = state.scan.filter(
        (item) => item.barcode !== action.payload
      );
      state.scan = removeItem;
    },
  },
});

export const scanReducer = scanSlice.reducer;
export const { addToScan, incrementQuantity, decrementQuantity, removeItem } =
  scanSlice.actions;
